import styled, { css } from 'styled-components'

import { FireLink } from '@nx/fire/link'
import { Body, Heading } from '@nx/fire/typography'

export const LotContainer = styled.div`
  position: relative;

  ${({ theme }) => theme.media.up.xl} {
    margin-top: -30px;
  }
`

export const LotBreadcrumbsContainer = styled.div`
  grid-area: A;
  padding-bottom: 1rem;

  ${({ theme }) => theme.media.up.lg} {
    padding-top: 1rem;
    height: 100%;
    position: sticky;
    top: 0;
    align-self: start;
    background-color: ${({ theme }) => theme.colours.grey['30']};
    z-index: ${({ theme }) => theme.zIndex.stickyBar};
  }
`

export const LotHeading = styled(Body)`
  ${({ theme: { colours } }) => css`
    color: ${colours.primary.charcoal};
  `}
  padding-bottom: 1rem;
  font-style: italic;
`

export const LotNavigationContainer = styled.div`
  grid-area: B;
  position: sticky;
  padding: 0.5rem 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colours.grey['30']};
  z-index: ${({ theme }) => theme.zIndex.stickyBar};

  ${({ theme }) => theme.media.up.lg} {
    padding: 1rem 0;
    height: 100%;
    top: 0;
    align-self: start;
  }
`

export const LotDetailsContainer = styled.div`
  display: grid;
  grid-template-areas: 'A A A A A' 'C C C C C' 'B B B B B' 'D D D D D' 'E E E E E';
  grid-template-columns: repeat(5, 20%);

  ${({ theme }) => theme.media.up.lg} {
    grid-template-areas: 'A A A B B' 'C C C C C' 'D D D D D' 'E E E E E';
  }

  ${({ theme }) => theme.media.up.xl} {
    grid-template-areas: 'A A A B B' 'C C C D D' 'E E E D D';
    grid-template-rows: min-content min-content 1fr;
  }
`

export const LotCarouselContainer = styled.div`
  grid-area: C;
  margin-bottom: 1rem;
  overflow: hidden;

  ${({ theme }) => theme.media.up.xl} {
    margin-bottom: 0;
  }
`

export const LotInfoContainer = styled.div`
  grid-area: D;

  ${({ theme }) => theme.media.up.xl} {
    padding-left: 30px;
  }
`

export const StyledLotTitle = styled.div`
  margin-top: 1rem;

  .firstLine {
    ${({ theme }) => theme.typography.heading.heading3}
  }

  .secondLine {
    ${({ theme }) => theme.typography.heading.heading5}
    ${({ theme }) => theme.fontStyles.sangbleuLivre}
    margin-top: 10px;
  }

  .otherLine {
    ${({ theme }) => theme.typography.body.M}
    margin-top: 10px;
  }
`

export const LotDescriptionContainer = styled.div`
  grid-area: E;
  display: flex;
  flex-direction: column;
  row-gap: 60px;
`

export const StyledLotStatusLabel = styled.div`
  ${({ theme }) => theme.typography.heading.heading6}
  margin-top: 20px;
`

export const StyledAuctionLinkContainer = styled.div`
  margin-top: 20px;
`

export const StyledAuctionLinkLabel = styled(FireLink)`
  ${({ theme }) => theme.typography.label.M}
`

export const StyledLocationLink = styled(FireLink)`
  color: black;

  &:hover {
    color: black;
  }
`

export const LotActions = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 30px;

  .cta-link {
    display: inline-block;
  }
`

export const StyledHeading = styled(Heading)`
  padding-bottom: 20px;
`

export const ContactsWrapper = styled.div`
  padding-top: 60px;
  padding-bottom: 13px;
  margin-bottom: -13px;
`

export const FollowPromoCardWrapper = styled.div`
  padding-top: 60px;
`

export const StyledBanner = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.colours.primary.white};
    box-shadow: ${theme.shadows.small};
    padding: 5px 0;
    position: relative;
  `}
`

export const StyledBannerInner = styled.div`
  align-items: center;
  display: flex;
  gap: 5px;
  margin-left: -5px;

  * {
    margin: 0;
  }
`

export const StyledBannerLink = styled(FireLink)`
  ${({ theme }) => css`
    ${theme.fontStyles.sourceSans.bold}
    text-decoration: underline;
  `}
`
